import { useTranslation } from 'react-i18next';
import styles from '../styles/Activity.module.scss';
import ActionCard from './ActionCard';
import { ActionDTO } from '@behavior/activity/dto/ActionDTO';
import useActionInitialData from '@behavior/activity/getActionInitialData';
import { useState, useEffect } from 'react';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { ActivityInitialDataResponse } from '@components/Activity/types/ActivityInitialDataResponse';

type Props = {
  actionCard: number[];
  setActionCard: (actionCard: number[]) => void;
  count: number;
  setCount: (count: number) => void;
  initialData?: ActivityInitialDataResponse;
  actionCardContent: ActionDTO;
  setActionCardContent: (actionCardContent: ActionDTO) => void;
  actionCardContentList: ActionDTO[];
  setActionCardContentList: (actionCardContentList: ActionDTO[]) => void;
  disabled?: boolean;
};

const ActionRequired = ({
  actionCard,
  setActionCard,
  count,
  setCount,
  initialData,
  actionCardContentList,
  setActionCardContentList,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const getInitialActionData = useActionInitialData();
  const [actionInitial, setActionInitial] = useState<ActionDTO>();

  const addActionCard = () => {
    setCount(count + 1);
    getInitialActionData.getActionInitialData().then(newInitialData => {
      setActionInitial(newInitialData);
    });

    setActionCard([...actionCard, count]);
  };

  useEffect(() => {
    if (actionInitial != undefined) {
      setActionCardContentList([...actionCardContentList, actionInitial]);
    }
  }, [actionInitial]);

  const removeActionCard = (cardKey: number) => {
    const updatedCards = actionCard.filter(key => key !== cardKey);
    setActionCard(updatedCards);
    const updatedCardsList = actionCardContentList.filter((_, index) => index !== cardKey);
    setActionCardContentList(updatedCardsList);
  };

  return (
    <>
      {!disabled && (
        <div>
          <div className={styles.addProductText}>
            {t('action.form.details.page.container.action.required.add.action')}
          </div>
          <div className="activityAddButtonWithMargin">
            <ButtonWrapper
              label="activity.details.page.components.activity.action.add"
              primary
              icon="add"
              onClick={addActionCard}
            />
          </div>
        </div>
      )}
      {[...actionCardContentList].reverse().map((cardContent, reversedIndex) => {
        const cardKey = actionCardContentList.length - 1 - reversedIndex;
        return (
          <div key={cardKey}>
            <ActionCard
              onRemove={() => removeActionCard(cardKey)}
              actionContent={cardContent}
              setActionCardContent={(newContent: ActionDTO) => {
                const updatedList = [...actionCardContentList];
                updatedList[cardKey] = newContent;
                setActionCardContentList(updatedList);
              }}
              initialData={initialData}
              disabled={disabled}
              index={cardKey}
            />
          </div>
        );
      })}
    </>
  );
};

export default ActionRequired;
